"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_AVATAR = void 0;
exports.DEFAULT_AVATAR = "/images/DefaultAvatar600x600.jpg";
//# sourceMappingURL=clientConstants.js.map